module.exports = __webpack_public_path__ + "static/img/当心腐蚀.e501d74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warnSign/当心腐蚀.png
// module id = +T1w
// module chunks = 1